export enum WalletTab {
  TRANSFERS = 'TRANSFERS',
  DEPOSIT = 'DEPOSIT',
  WITHDRAW = 'WITHDRAW',
}
